import { render, staticRenderFns } from "./formBox.vue?vue&type=template&id=505eb2da&scoped=true"
import script from "./formBox.vue?vue&type=script&lang=js"
export * from "./formBox.vue?vue&type=script&lang=js"
import style0 from "./formBox.vue?vue&type=style&index=0&id=505eb2da&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505eb2da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('505eb2da')) {
      api.createRecord('505eb2da', component.options)
    } else {
      api.reload('505eb2da', component.options)
    }
    module.hot.accept("./formBox.vue?vue&type=template&id=505eb2da&scoped=true", function () {
      api.rerender('505eb2da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/cloudfile/components/layout/formBox.vue"
export default component.exports